exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apexcharts-legend.apx-legend-position-right{justify-content:center!important}", ""]);

// exports
